import loadable from "@loadable/component";
import { FC } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import StatusIcon from "../../Icons/StatusIcon";

const AuthorListComponent = loadable(
  () => import("../../components/Author/AuthorList") as unknown as Promise<FC>
);

export const AuthorList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Authors</span>
      </div>
      <AuthorListComponent />
    </>
  );
};
